<template>
  <header id='header' :class='{Restring: !fullVUi}'>
    <div class='inner'>
      <div class='col col1' v-if="appFlag || groupQr" @click="backBtn">
        <a class="backBtn">
          <span class='ico icoBack'></span>
        </a>
      </div>
      <div class='col col2' :class="{ml8 : !appFlag && !groupQr}">
        <h1>{{MultiLangStoreName}}</h1>
      </div>
      <div class='col col3'>
        <a class='btnNavi langNavi' v-if="this.globalType == 1 && this.isGlobalButtonEnabled()">
          <span
            @click="toggleLangBox()"
            class="ico lang"
            :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
          <div class="langBox" style="display: none">
            <span class="ico lang ko" @click="setKorean()"></span>
            <span class="ico lang en" @click="setEnglish()"></span>
            <span class="ico lang ch" @click="setChinese()"></span>
          </div>
        </a>
        <a v-if='fullVUi' class='btnNavi sch' @click='moveToSearchPage()'>
          <span class='ico'>검색</span>
        </a>
        <a v-if='this.appFlag' class='btnNavi all-menu' @click='allMenuToggleEmit'>
          <span class='ico'>메뉴</span>
        </a>
      </div>
    </div>
  </header>
</template>
<!-- mixin 사용하려면 javascript -->
<script lang="js">
import { REQ_STORE_INFO } from '@/store/_actions/actionTypes'
import { FAIL_TO_REQ_STORE_INFO } from '@/utils/Message'
import { MAIN_HEADER } from '@/utils/EndPoint'
import { THROW_MYPAGE, THROW_SEARCH, THROW_ERROR } from '@/router'

import $ from 'jquery'
import Vue from 'vue'

export default Vue.extend({
  name: MAIN_HEADER,
  props: ['cartFlag'],
  data () {
    return {
      storeGroupName: this.$store.getters.storeGroupName,
      fullVUi: this.$store.getters.fullVUi
    }
  },
  computed: {
    MultiLangStoreName () {
      return this.$store.state.MainPage.MultiLangStoreName
    },
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    globalType () {
      return this.$store.state.MainIndex.globalType
    },
    groupQr () {
      return !!sessionStorage.getItem('GroupQrData')
    }
  },
  created () {
    sessionStorage.getItem('langType')
      ? this.$i18n.locale = sessionStorage.getItem('langType')
      : this.$i18n.locale = this.$store.getters.langType
  },
  methods: {
    backBtn () {
      if (sessionStorage.getItem('openAreaAccept')) {
        this.$router.push({ name: 'OpenAreaStoreList' })
      } else if (sessionStorage.getItem('categoryCode') || sessionStorage.getItem('tradition')) {
        this.$router.push({ name: 'AppStoreList' })
      } else {
        this.appMoveMain()
      }
    },
    // 상점 정보 요청
    showStoreInfo () {
      this.$store.dispatch(REQ_STORE_INFO)
        .then(() => { this.createPopUp('#store.cusLayer') })
        .catch(() => { this.toast(this, FAIL_TO_REQ_STORE_INFO) })
    },
    // moveToMyPage () { THROW_MYPAGE() },
    moveToSearchPage () {
      // THROW_SEARCH()
      this.$router.push({
        name: 'SEARCH',
        query: {
          searchType: 0
        }
      })
    },
    toggleLangBox () {
      $('#header .langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    }
  }
})

</script>
<style scoped>
  #header .col2 h1 {
    display: block;
}
</style>
